import { PersistenceId } from "../../../_config/PersistenceId";

export class BonDeCommandeId extends PersistenceId {
    get PREFIX_ID() {
        return "BC"
    }
}

